import { StorageService } from '@nextgen-web-framework/core';
import { CartConstantsEnum } from '../types';
import { CartEntryDetails } from '../services/models/CartEntryDetails';
import { Cart, ListEntry, OrderType } from '../services';
import { CartEvents } from './cartEventsUtil';
import { CART_TYPE } from './cartCommonHelpers';

export type PublishEventProps = {
  cartEvent: string;
  cartEntry?: CartEntryDetails;
  cartId?: string;
  cart?: Cart;
};

export type PublishWishlistEventProps = {
  cartEvent: string;
  listEntry?: ListEntry;
};

export const PublishEvent = (value: PublishEventProps) =>
  CartEvents.publishEvent({
    event: value.cartEvent,
    payload: {
      cart: value.cart,
      cartId: value?.cartId || StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartId),
      cart_type: value?.cart?.orderType === OrderType.Gco ? CART_TYPE.GROUP : CART_TYPE.PERSONAL,
      product_brand: value.cartEntry?.product.brand,
      product_businessVolume: value.cartEntry?.retailPrice?.amwayValue?.businessVolume,
      product_id: value.cartEntry?.product.id,
      product_name: value.cartEntry?.product.name,
      product_pointValue: value.cartEntry?.retailPrice?.amwayValue?.pointValue,
      product_unitPrice: value.cartEntry?.retailPrice?.value,
      product_units: value.cartEntry?.quantity,
      product_referrer: '',
      product_promo: value.cartEntry?.promotionResults?.firedPromotions?.map((promo) => promo?.promotion?.promoCode),
    },
    sync: true,
  });

export const PublishWishlistEvent = (value: PublishWishlistEventProps) =>
  CartEvents.publishEvent({
    event: value.cartEvent,
    payload: {
      product_brand: value.listEntry?.product.brand,
      product_id: value.listEntry?.product.id,
      product_pointValue: value?.listEntry?.totalPrice?.amwayValue?.pointValue,
      product_name: value.listEntry?.product.name,
      product_unitPrice: value.listEntry?.retailPrice?.value,
      product_units: value.listEntry?.quantity,
    },
    sync: true,
  });
